import React, { useCallback } from 'react';
import { reduxForm, Field } from 'redux-form';
import SigninField from './SigninField';
import { connect } from 'react-redux';
import { signin } from '../../actions';

const Signin = ({ handleSubmit, signin, history, errorMessage }) => {
  const onSubmit = useCallback(
    (formProps) => {
      signin(formProps, () => history.push('/'));
    },
    [signin, history]
  );

  return (
    <div>
      <h5>Sign in to continue to DESOURO PORTAL</h5>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field
          id="name"
          label="Username"
          name="username"
          type="text"
          autoComplete="none"
          component={SigninField}
        />
        <Field
          id="pass"
          label="Password"
          name="password"
          type="password"
          autoComplete="none"
          component={SigninField}
        />
        <button className="btn">
          Sign In<i className="material-icons right">send</i>
        </button>
        <div>{errorMessage}</div>
      </form>
    </div>
  );
};

function mapStateToProps(state) {
  return { errorMessage: state.auth.errorMessage };
}

export default reduxForm({ form: 'signin' })(
  connect(mapStateToProps, { signin })(Signin)
);
